import React, { useState, useEffect } from 'react';
import { PerformancePageContainer, BusinessInfoContainer } from './styled';
import { TabBar, BusinessInfoCard } from "../../components"
import { COMPLETED, IN_PROGRESS, PLANNED } from "../../const"

function PerformancePage() {
    const tabNames = ["예정", "진행중", "완료"];

    const [tab, setTab] = useState(tabNames[0]);
    const [businessList, setBusinessList] = useState(PLANNED);

    useEffect(() => {
        if(tab === tabNames[0]) setBusinessList(PLANNED);
        if(tab === tabNames[1]) setBusinessList(IN_PROGRESS);
        if(tab === tabNames[2]) setBusinessList(COMPLETED);
      }, [tab]);

    return (
        <PerformancePageContainer>

            <h1 className="header">사업실적</h1>

            <TabBar list={tabNames} current={tab} setCurrent={setTab}/>

            <BusinessInfoContainer>
                {businessList.map((item, idx) => {
                    return (
                        <BusinessInfoCard business={item} />
                    )
                })}
            </BusinessInfoContainer>

        </PerformancePageContainer>
    );
}

export default PerformancePage;